import { FEATURE, PLAN_CODE, type Feature, type PlanCode } from "@/server/types/billing";
import type { RequiredPlanEntry } from "@/frontend/types/billing";

/** Human labels used everywhere in the dashboard billing surface. */
export const PLAN_LABEL: Record<PlanCode, string> = {
  [PLAN_CODE.FREE]: "Free",
  [PLAN_CODE.ENTERPRISE]: "Enterprise",
};

/** Tier labels for the sidebar quota card. Keyed by plan code so a new plan fails the type check. */
export const PLAN_TIER_LABEL: Record<PlanCode, string> = {
  [PLAN_CODE.FREE]: "Free tier",
  [PLAN_CODE.ENTERPRISE]: "Enterprise",
};

/** Cheapest plan that unlocks each gated feature. */
export const REQUIRED_PLAN: Record<Feature, RequiredPlanEntry> = {
  [FEATURE.WEARABLE_SYNC]: { code: PLAN_CODE.FREE, label: PLAN_LABEL[PLAN_CODE.FREE] },
  [FEATURE.EXPORT_DESTINATIONS]: { code: PLAN_CODE.FREE, label: PLAN_LABEL[PLAN_CODE.FREE] },
  [FEATURE.BACKEND_SERVICES]: { code: PLAN_CODE.ENTERPRISE, label: PLAN_LABEL[PLAN_CODE.ENTERPRISE] },
  [FEATURE.CLINICAL_WORKFLOWS]: { code: PLAN_CODE.ENTERPRISE, label: PLAN_LABEL[PLAN_CODE.ENTERPRISE] },
  [FEATURE.CUSTOM_EHR_CLIENT_IDS]: { code: PLAN_CODE.FREE, label: PLAN_LABEL[PLAN_CODE.FREE] },
  [FEATURE.OCR]: { code: PLAN_CODE.ENTERPRISE, label: PLAN_LABEL[PLAN_CODE.ENTERPRISE] },
  [FEATURE.DATA_STRUCTURING]: { code: PLAN_CODE.ENTERPRISE, label: PLAN_LABEL[PLAN_CODE.ENTERPRISE] },
};

/** Short human label per gated feature used in the upsell copy. */
export const FEATURE_LABEL: Record<Feature, string> = {
  [FEATURE.WEARABLE_SYNC]: "Wearable device integration",
  [FEATURE.EXPORT_DESTINATIONS]: "Export destinations",
  [FEATURE.BACKEND_SERVICES]: "Direct EHR integration (Backend Services)",
  [FEATURE.CLINICAL_WORKFLOWS]: "Clinical workflows & CDS Hooks",
  [FEATURE.CUSTOM_EHR_CLIENT_IDS]: "Custom EHR client IDs",
  [FEATURE.OCR]: "OCR",
  [FEATURE.DATA_STRUCTURING]: "Data structuring",
};
